import { z } from 'zod';
type Scalar = string | number | boolean | null;
type Level1 = Scalar | Scalar[] | { [key: string]: Scalar };
type Level2 = Level1 | Level1[] | { [key: string]: Level1 };
type Level3 = Level2 | Level2[] | { [key: string]: Level2 };
type Level4 = Level3 | Level3[] | { [key: string]: Level3 };
type Level5 = Level4 | Level4[] | { [key: string]: Level4 };
export type MetadataJson = Level5 | Level5[] | { [key: string]: Level5 };
/** Bound nested metadata for schema validation and Workers RPC serialization. */
function valid(value: unknown, depth: number): boolean {
  if (value === null || typeof value === 'string' || typeof value === 'boolean') return true;
  if (typeof value === 'number') return Number.isFinite(value);
  if (depth <= 0 || typeof value !== 'object') return false;
  if (Array.isArray(value)) return value.every(item => valid(item, depth - 1));
  return Object.getPrototypeOf(value) === Object.prototype && Object.values(value).every(item => valid(item, depth - 1));
}
export const MetadataJsonSchema = z.custom<MetadataJson>(value => valid(value, 6), 'Metadata settings must contain bounded JSON values.');
